import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Chen',
  role: 'CEO',
  company: 'TechVision',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop',
  content: 'SalesMax transformed our entire go-to-market strategy. We went from 5 qualified leads per month to 50+ in just 8 weeks. The AI-powered outbound is incredible.',
  result: '10x lead growth'
}, {
  name: 'Michael Rodriguez',
  role: 'VP of Marketing',
  company: 'DataFlow',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop',
  content: "The team's expertise combined with AI automation gave us enterprise-level marketing at a fraction of the cost. Our CAC dropped 60% while pipeline doubled.",
  result: '60% lower CAC'
}, {
  name: 'Emily Watson',
  role: 'Founder',
  company: 'CloudSync',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop',
  content: 'I was skeptical about AI marketing, but SalesMax proved me wrong. They delivered personalized campaigns at scale that actually convert. Best investment we made.',
  result: '4.5x ROI'
}];
export function Testimonials() {
  return <div className="py-24 bg-gradient-to-br from-gray-50 to-blue-50" data-id="element-214">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-216">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" data-id="element-217">
            Trusted by Forward-Thinking
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-218">
              Companies
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-219">
            See how we have helped companies scale their revenue with AI-powered
            marketing
          </p>
        </div>
        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8" data-id="element-220">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100" data-id="element-221">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-222">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-223" />)}
              </div>
              {/* Quote */}
              <QuoteIcon className="w-8 h-8 text-blue-200 mb-4" data-id="element-224" />
              {/* Content */}
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-225">
                {testimonial.content}
              </p>
              {/* Result Badge */}
              <div className="inline-flex items-center bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6" data-id="element-226">
                {testimonial.result}
              </div>
              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-gray-100" data-id="element-227">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover" data-id="element-228" />
                <div data-id="element-229">
                  <div className="font-semibold text-gray-900" data-id="element-230">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-gray-600" data-id="element-231">
                    {testimonial.role}, {testimonial.company}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}